import { Hub } from 'aws-amplify'

export const syncQueriesReady = (fetchData, filterFunc) => {
  const listener = ({ payload: { event, data } }) => {
    if (event === 'syncQueriesReady') { // or 'ready' ?
      fetchData(filterFunc)
    }
  }
  Hub.listen('datastore', listener)
  fetchData(filterFunc)
  return listener
}
export const removeSync = (listener) => {
  Hub.remove('datastore', listener)
}